// @flow
import React, { Component, Fragment } from "react";

import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

import LicenceItemTable from "./LicenceItemTable";
import { DeleteButton, ConfirmCancelDialog } from "imagus-components";

type HistoryItemStatesType = {
  isLoading: boolean,
  modalOpen: boolean
};

type HistoryItemPropsType = {
  history: { [key: string]: * },
  downloadFile: Function,
  deleteLicenceHistory: Function,
  setActionError: Function
};

class HistoryItem extends Component<
  HistoryItemPropsType,
  HistoryItemStatesType
> {
  constructor(props: HistoryItemPropsType) {
    super(props);
    this.state = {
      isLoading: false,
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  };

  render(): React$Element<*> {
    const isDeleted = this.props.history.deletedBy !== null;

    return (
      <Fragment>
        <Grid item xs={11}>
          <Paper
            className="box-wrapper bottom-margin-10"
            style={isDeleted ? { opacity: 0.5, maxHeight: "65px" } : {}}
          >
            <LicenceItemTable
              licence={this.props.history}
              downloadFile={this.props.downloadFile}
              isHistory
              isImagusAdmin
            />
          </Paper>
        </Grid>
        {!isDeleted && (
          <Grid item xs={1} style={{ paddingTop: "90px" }}>
            <DeleteButton
              loading={this.state.isLoading}
              buttonClass="right-margin-5"
              onClick={(): * => this.switchModalStatus(true)}
            />
            <ConfirmCancelDialog
              open={this.state.modalOpen}
              handleModalStatus={this.switchModalStatus}
              deleteFunction={(): * => {
                this.setState({ isLoading: true });
                this.props.deleteLicenceHistory(
                  this.props.history.id,
                  (): * => this.setState({ isLoading: false }),
                  this.props.setActionError
                );
              }}
              itemName={"This Licence History"}
            />
          </Grid>
        )}
      </Fragment>
    );
  }
}

type LicenceHistoriesPropsType = {
  histories: Array<*>,
  downloadFile: Function,
  deleteLicenceHistory: Function,
  setActionError: Function
};

class LicenceHistories extends Component<LicenceHistoriesPropsType, *> {
  render(): React$Element<*> {
    const histories = this.props.histories;

    return (
      <div className="app-wrapper">
        <div className="app-panel">
          <div className="app-panel-content">
            <Typography variant="h5" className="form-text bottom-margin-15">
              Licence Histories
            </Typography>
            <Grid container spacing={8}>
              {histories.map((history: *, i: number): * => (
                <HistoryItem
                  key={i}
                  history={history}
                  downloadFile={this.props.downloadFile}
                  deleteLicenceHistory={this.props.deleteLicenceHistory}
                  setActionError={this.props.setActionError}
                />
              ))}
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default LicenceHistories;
